import React, {useState, useEffect} from 'react'
import { Container, Row } from 'react-bootstrap'


import "../buidl.css";


function Moreintro() {

   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  
    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    // const handleContextMenu = (e) => {
    //   e.preventDefault(); // Disable right-click
    // };


  return (
    <Container 
    fluid 
    className='container-section' 
    style={{
      backgroundColor:"272A38",
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: isSmallScreen ? 'auto' : '100vh',
      paddingBottom: isSmallScreen ? '5rem' : 'auto',
       paddingTop: isSmallScreen ? '5rem' : 'auto',
      color: 'white',
      }}>
        <Row style={{ height: "auto", width: "100%"}}>
          <h2 style={{fontWeight:"bold",fontSize:"3rem"}}>About</h2>
          <p style={{fontSize:"0.88rem"}}>At the core of Buidl is its advanced AI technology, Buidl AI, which streamlines the entire hiring process. It intelligently matches talents to projects based 
          on their skills, experience, and interests, making the selection process more efficient and precise. This automation eliminates friction, allowing builders to find 
          qualified professionals quickly while ensuring applicants are paired with projects that align with their expertise.</p>

           <p style={{marginTop:"30px", fontSize:"0.88rem"}}>With its seamless AI-driven workflow, Buidl transforms the way collaboration happens in the digital space. By leveraging smart automation, it enhances 
            efficiency, reduces hiring complexities, and fosters a dynamic community where innovation thrives. Whether you're looking to build a groundbreaking project 
            or contribute your expertise to meaningful work, Buidl is the perfect platform to connect, collaborate, and create.</p>
        </Row>
       
    </Container>
    
     
    
  )
}

export default Moreintro